import React, { Component } from "react";
import $ from "jquery";

{/* 
    <meta property="og:image" content="assets/css/gfx/skold.png" />
    <meta property="og:title" content="Den historie hjemmesiden for Norges Golfforbund" />
    <meta property="og:description" content="Her finner du alle de historie tingene som har skjedd i Norges golfhistorie gjennom tidene" />
    <meta property="og:url" content="http://###" />
    <meta property="og:site_name" content="Norges Golfklubb" />
    <meta property="og:type" content="sport" /> 
*/}

class Recat extends Component {
    constructor(props) {
        super(props);
        this.state = {
            title: this.props.title ? this.props.title : null,
            image: this.props.image ? this.props.image : null,
            description: this.props.description ? this.props.description : null,
            url: this.props.url ? this.props.url : null,
            site_name: this.props.site_name ? this.props.site_name : null,
            type: this.props.type ? this.props.type : null,
        };
    }

    async componentDidMount() {
        console.log('fhfdtgtruj ', this.props);
        this.mataTag();
    }

    async mataTag() {

        if ($("meta[name='image']").length && this.state.image !== null) {
            $("meta[name='image']").attr("content", this.state.image);
        } else if (this.state.image !== null) {
            $('head').prepend('<meta name="image" content="' + this.state.image + '" />');
        }

        if ($("meta[name='title']").length && this.state.title !== null) {
            $("meta[name='title']").attr("content", this.state.title);
        } else if (this.state.title !== null) {
            $('head').prepend('<meta name="title" content="' + this.state.title + '" />');
        }

        if ($("title").length && this.state.title !== null) {
            $("title").html(this.state.title);
        } else if (this.state.title !== null) {
            $('head').prepend('<title>' + this.state.title + '</title>');
        }

        if ($("meta[name='description']").length && this.state.description !== null) {
            $("meta[name='description']").attr("content", this.state.description);
        } else if (this.state.description !== null) {
            $('head').prepend('<meta name="description" content="' + this.state.description + '" />');
        }

        if ($("meta[name='url']").length && this.state.url !== null) {
            $("meta[name='url']").attr("content", this.state.url);
        } else if (this.state.url !== null) {
            $('head').prepend('<meta name="url" content="' + this.state.url + '" />');
        }

        if ($("meta[name='site_name']").length && this.state.site_name !== null) {
            $("meta[name='site_name']").attr("content", this.state.site_name);
        } else if (this.state.site_name !== null) {
            $('head').prepend('<meta name="site_name" content="' + this.state.site_name + '" />');
        }

        if ($("meta[name='type']").length && this.state.type !== null) {
            $("meta[name='type']").attr("content", this.state.type);
        } else if (this.state.type !== null) {
            $('head').prepend('<meta name="type" content="' + this.state.type + '" />');
        }
    }

    render() {
        return (
            <div style={{display: 'none'}}>
                demo
            </div>
        )
    }
}

async function Mata(data) {

    // { title, image, description, url, site_name, type }
    if ($("meta[name='image']").length && typeof (data.image) !== "undefined") {
        $("meta[name='image']").attr("content", typeof (data.image));
    } else if (typeof (data.image) !== "undefined") {
        $('head').prepend('<meta name="image" content="' + typeof (data.image) + '" />');
    }

    if ($("meta[name='title']").length && typeof (data.title) !== "undefined") {
        $("meta[name='title']").attr("content", typeof (data.title));
    } else if (typeof (data.title) !== "undefined") {
        $('head').prepend('<meta name="title" content="' + typeof (data.title) + '" />');
    }

    if ($("title").length && typeof (data.title) !== "undefined") {
        $("title").html(typeof (data.title));
    } else if (typeof (data.title) !== "undefined") {
        $('head').prepend('<title>' + typeof (data.title) + '</title>');
    }

    if ($("meta[name='description']").length && typeof (data.description) !== "undefined") {
        $("meta[name='description']").attr("content", typeof (data.description));
    } else if (typeof (data.description) !== "undefined") {
        $('head').prepend('<meta name="description" content="' + typeof (data.description) + '" />');
    }

    if ($("meta[name='url']").length && typeof (data.url) !== "undefined") {
        $("meta[name='url']").attr("content", typeof (data.url));
    } else if (typeof (data.url) !== "undefined") {
        $('head').prepend('<meta name="url" content="' + typeof (data.url) + '" />');
    }

    if ($("meta[name='site_name']").length && typeof (data.site_name) !== "undefined") {
        $("meta[name='site_name']").attr("content", typeof (data.site_name));
    } else if (typeof (data.site_name) !== "undefined") {
        $('head').prepend('<meta name="site_name" content="' + typeof (data.site_name) + '" />');
    }

    if ($("meta[name='type']").length && typeof (data.type) !== "undefined") {
        $("meta[name='type']").attr("content", typeof (data.type));
    } else if (typeof (data.type) !== "undefined") {
        $('head').prepend('<meta name="type" content="' + typeof (data.type) + '" />');
    }
}
export default {
    Recat,
    Mata
};